<h2 class="secondary-header first-letter:uppercase">{{ subjects().title }}</h2>
<div class="grid gap-3 leading-6 sm:grid-cols-3">
	@for (subject of subjects().subjects; track subject.name) {
		<a
			(click)="setSearchLocation()"
			[routerLink]="[basePath(), subject.link]"
			class="blue-link-underline first-letter:uppercase max-w-max"
			data-cy="degree-subject-link"
			>{{ subject.name }}</a
		>
	}
</div>
